import {
  Brand,
  Category,
  Collection,
  Crop,
} from '@dehaat/kisan-app-bl/models/Product'

import { FilterTypes } from '@/constants/filterTypes'
import { PolicyFilterTypes } from '@/constants/insurance'
import { Filter, PolicyFilterObjProps } from '@/models/insurance'
import { FilterObjProps } from '@/models/Product'

export const getCropsFilterList = (crops: Crop[]): FilterObjProps[] => {
  return crops.map(({ languageVariant, data, id }) => {
   const name =
      languageVariant?.edges?.[0]?.node?.name?.trim() || ''
    let imageUrl = ''
    try {
      if (data) {
        const imageData = JSON.parse(data)
        imageUrl = imageData.photo[0]?.aeros_image_url
      }
    } catch {}
    return {
      key: `${FilterTypes.CROPS}-${name}`,
      name,
      id,
      type: FilterTypes.CROPS,
      imageURL: imageUrl,
    }
  })
}


export const getCategoryFilterList = (
  categories: Category[]
): FilterObjProps[] =>
  categories.map(({ id, name, appDisplayName, imageUrl }) => ({
    key: `${FilterTypes.CATEGORY}-${id}`,
    name: appDisplayName || name,
    id,
    type: FilterTypes.CATEGORY,
    imageURL: imageUrl || '',
  }))

export const getBrandsFilterList = (brands: Brand[]): FilterObjProps[] =>
  brands.map(({ id, name, imageUrl }) => ({
    key: `${FilterTypes.BRANDS}-${id}`,
    name,
    id,
    type: FilterTypes.BRANDS,
    imageURL: imageUrl || '',
  }))

export const getPolicyFilterList = (
  filter: Filter[],
  type: PolicyFilterTypes
): PolicyFilterObjProps[] =>
  filter.map(({ id, name }) => ({
    key: `${type}-${id}`,
    name,
    id: id.toString(),
    type,
  }))
